import { render, staticRenderFns } from "./Inactive.vue?vue&type=template&id=01090c11&scoped=true&"
import script from "./Inactive.vue?vue&type=script&lang=js&"
export * from "./Inactive.vue?vue&type=script&lang=js&"
import style0 from "./Inactive.vue?vue&type=style&index=0&id=01090c11&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01090c11",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VIcon,VRow})
